<template>  
    <router-link :to="href" class="el-link"><slot></slot></router-link>  	
</template>

<script>
export default {
  name: 'url',
  props: {
       href: {default:'',type:String},	   
  },
  
}
</script>
<style>
	.el-link{color: #606266;}
	.el-link:hover{color: #409eff;}
</style>


